export enum SnomedCT {
  MaternalPerinatalCare = "1255917009",
  ProfessionalMidwife = "75271001",
  Consultation = "11429006",
  RenewalOfPrescription = "103742009",
  UrgentFollowUp = "406547006",
  FollowUp = "185389009",
  TestResultToPatientPersonally = "142768006",
  Dermatologist = "18803008",
  GeneralPractitionerPrincipal = "309394004",
  Gynecologist = "83685006",
  Ophtalmologist = "422234006",
  GeriatricsSpecialist = "90655003",
  //https://www.findacode.com/snomed/702601001--routine-gynecologic-examination.html?hl=gynecology
  RoutineGynecologicalExamination = "702601001",
  //https://www.findacode.com/snomed/268445003--ultrasound-scan-obstetric.html?hl=Obstetric+ultrasound
  UltrasoundScan = "268445003",
  //https://www.findacode.com/snomed/711029005--counseling-about-breastfeeding.html?hl=breastfeeding
  CounselingAboutBreastfeeding = "711029005",
  //https://www.findacode.com/snomed/386235000--childbirth-preparation.html?hl=childbirth
  ChildBirthPreparation = "386235000",
  //https://www.findacode.com/snomed/788122004--sexual-health-service.html?hl=sexual+health
  SexualHealthService = "788122004",
  //https://www.findacode.com/snomed/2651000175101--womens-health-service.html
  WomensHealthService = "2651000175101",
  //https://www.findacode.com/snomed/133906008--postpartum-care.html?hl=postpartum+care
  PostpartumCare = "133906008",
  //https://browser.ihtsdotools.org/?perspective=full&conceptId1=702882007&edition=MAIN/2024-10-01&release=&languages=en
  MentalHealthClinic = "702882007",
}

export enum SnomedCTExpertiseLabel {
  RoutineGynecologicalExamination = "Gynécologie préventive",
  UltrasoundScan = "Échographie obstétricale",
  CounselingAboutBreastfeeding = "Conseil en allaitement",
  ChildBirthPreparation = "Préparation à la naissance",
  SexualHealthService = "Consultation de santé sexuelle",
  WomensHealthService = "Consultation de santé de la femme",
  PostpartumCare = "Consultation post-partum",
  Dermatologist = "Dermatologue",
  GeneralPractitionerPrincipal = "Médecin généraliste",
  Gynecologist = "Gynécologue",
  Ophtalmologist = "Ophtalmologue",
  GeriatricsSpecialist = "Gériatre",
}
